export function  formatCurrency(value){
  return `${value??0}`.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
}

export function numberOrZero(value){
  return isNaN(Number(value))?0:Number(value);
}